import * as yup from 'yup';

import {
  CreateOfferingDraftInput,
  OfferingType,
  SecurityType,
  UpdateBasicInfoInput,
} from '../../../graphql';
import { PP_SECURITY_TYPES } from '../../../types/domain/security/constants';

export type FormType = (Omit<CreateOfferingDraftInput, 'isInternal'> | UpdateBasicInfoInput) & {
  isInternal: boolean | null;
};

export const getValidationSchema = (hasInternalOfferingsTrait: boolean) =>
  yup.object().shape({
    isInternal: yup
      .boolean<boolean>()
      .nullable()
      .label('Offering Visibility')
      .when((_, schema) => {
        if (hasInternalOfferingsTrait) {
          return schema.required();
        }
        return schema;
      }),
    type: yup.string().label('Offering Type').required(),
    issuer: yup.object().shape({
      name: yup.string().label('Issuer Name').nullable().required(),
      subSector: yup.string().label('Sub-Sector').nullable(),
    }),
    security: yup
      .object()
      .shape({
        securityDescription: yup.string().label('Security Description').nullable().max(500),
      })
      .when(['type'], ([type], schema) => {
        if (type === OfferingType.Convertible) {
          return schema.shape({
            type: yup
              .string()
              .label('Security Type')
              .oneOf(
                [SecurityType.ConvertibleBond, SecurityType.PreferredShare],
                'Convertible Bonds or Preferred Share is required'
              )
              .required('Security Type is required'),
          });
        }
        if (type === OfferingType.PrivatePlacement) {
          return schema.shape({
            type: yup
              .string()
              .label('Security Type')
              .oneOf(PP_SECURITY_TYPES, 'Security Type is required')
              .required('Security Type is required'),
          });
        }
        return schema.shape({
          type: yup
            .string()
            .label('Security Type')
            .oneOf(
              Object.values(SecurityType).filter(value => value !== SecurityType.Fund),
              'Security Type is required'
            )
            .required('Security Type is required'),
        });
      }),
    pricingCurrencyCode: yup.string().label('Pricing Currency Code').required(),
    isWallCrossEnabled: yup.boolean().label('Wall Cross').nullable(),
  });
